const NotificationTypes = {
    ALL: [1, 2, 3],
    NEWS: 1,
    CUSTOM: 2,
    ALERT: 3
  }
  
  export default NotificationTypes